<template>
  <div id="app" class="app" :class="{back:back_flag}" v-loading.fullscreen.lock="screenFullFlag">
      <router-view></router-view>
  </div>
</template>

<script>

    import { mapState } from "vuex"
export default {
    name: 'app',
    components: {

    },
    data(){
        return {
            
        }
    },

    computed:{
        ...mapState(['screenFullFlag']),
        back_flag(){  //判断后台页面 给全屏loading换颜色
            return this.$route.path.split("/")[1] === "backstage";
        },
    },


}
</script>

<style lang="less">
    @import "~src/assets/less/common.less";
    .app{
        min-width: @screen;
    }
</style>



// WEBPACK FOOTER //
// App.vue?127a2772